export function TermsContentEn() {
  return (
    <div className="space-y-6 text-sm">
      <h2 className="text-lg font-semibold mb-3">Part C License Terms</h2>

      <section>
        <h3 className="font-semibold mb-2">§ C-1 Scope of the License Terms</h3>
        <p className="mb-3">
          (1) These License Terms govern the granting and scope of the rights of use for the
          software provided by BLIKS IO. They apply to any use of the software by the customer,
          regardless of
        </p>
        <p className="mb-1 ml-4">
          a) whether the use is within the scope of a contractual relationship involving payment,
        </p>
        <p className="mb-1 ml-4">
          b) whether it is a test, pilot, beta, or other pre-contractual use, or
        </p>
        <p className="mb-3 ml-4">
          c) whether the use is in connection with a technically necessary transition or settlement
          phase after the termination of a contract.
        </p>
        <p className="mb-3">
          (2) Any use of the software is permitted exclusively on the basis of these license terms.
        </p>
        <p className="mb-3">
          (3) If a separate contractual relationship exists between the parties, the term,
          remuneration, scope of services, and liability shall be determined in accordance with the
          provisions agreed therein.
        </p>
        <p className="mb-3">
          (4) If expressly agreed, licensing may take place within the framework of a reseller,
          white label, or platform model. In this case, separate license metrics (in particular seat
          or client models) shall apply in accordance with the individual agreement. Without express
          agreement, such B2B2B licensing shall not take place.
        </p>
      </section>

      <section>
        <h3 className="font-semibold mb-2">§ C-2 Granting of rights of use (basic license)</h3>
        <p className="mb-3">
          (1) BLIKS IO grants the customer a non-exclusive, non-transferable, and non-sublicensable
          right to use the software to the extent specified in the contract for the duration of the
          respective permitted use.
        </p>
        <p className="mb-3">
          (2) Use is permitted exclusively for the customer's own business purposes and only within
          the scope of the agreed usage parameters (in particular, number of users, scope of
          functions, or other license metrics).
        </p>
        <p className="mb-3">
          (3) Transferring the software to third parties, making it accessible to third parties, or
          using it for third parties is only permitted if this has been expressly agreed.
        </p>
        <p className="mb-3">
          (4) With the exception of the rights expressly granted in these license terms, the
          customer is not granted any further rights of use or exploitation. All rights to the
          software, including all copyrights, industrial property rights, and other intellectual
          property rights, remain with BLIKS IO.
        </p>
      </section>

      <section>
        <h3 className="font-semibold mb-2">§ C-2a License metrics and cluster structure (B2B)</h3>
        <p className="mb-3">
          (1) In the standard B2B model, licensing is user-based according to the size of the
          customer's organization (&ldquo;cluster model&rdquo;). The size class agreed in the order
          form is decisive. This determines the maximum permissible number of authorized users
          within the licensee organization. Individual user licenses (&ldquo;seats&rdquo;) are not
          assigned on a personal basis in the standard B2B model.
        </p>
        <p className="mb-3">
          (2) Seat or client licensing shall only apply if the parties expressly agree on a
          reseller, white label, or other B2B2B model. Without such an express agreement, use by
          third parties is not permitted.
        </p>
        <p className="mb-3">
          (3) The customer is not entitled to provide the software or individual functionalities to
          third parties as a stand-alone, substitute, or economically comparable solution, to resell
          them, or to integrate them into their own platform or service offering, unless an express
          agreement to this effect has been made.
        </p>
        <p className="mb-3">
          (4) The technical multi-tenancy capability of the software does not grant any independent
          right of use to additional organizations, affiliated entities, or other legally separate
          units.
        </p>
      </section>

      <section>
        <h3 className="font-semibold mb-2">§ C-3 Scope of Use and Restrictions</h3>
        <p className="mb-3">(1) The customer is prohibited from</p>
        <p className="mb-1 ml-4">
          a) making the software accessible to unauthorized third parties or operating it for third
          parties,
        </p>
        <p className="mb-1 ml-4">
          b) circumventing technical protection measures or manipulating security mechanisms,
        </p>
        <p className="mb-3 ml-4">
          c) reproducing, distributing, making publicly available, or otherwise exploiting the
          software, unless this is necessary for contractual use.
        </p>
        <p className="mb-3">
          (2) Editing, decompiling, or any other form of reverse engineering is only permitted to
          the extent that this is expressly permitted by mandatory legal provisions.
        </p>
        <p className="mb-3">
          (3) The customer must take appropriate organizational measures to prevent any use of the
          software that is contrary to the contract.
        </p>
      </section>

      <section>
        <h3 className="font-semibold mb-2">§ C-4 Test, Beta, and Pre-Contract Use</h3>
        <p className="mb-3">
          (1) If the software is made available to the customer for testing, piloting, beta testing,
          or other evaluation purposes (&ldquo;Test Use&rdquo;) prior to the conclusion of a paid
          contractual relationship, such use shall be governed exclusively by these license terms.
        </p>
        <p className="mb-3">
          (2) Test use is limited to the evaluation of the software and may not be used for
          productive business purposes, unless expressly agreed otherwise.
        </p>
        <p className="mb-3">
          (3) The granting of rights of use within the scope of test use is free of charge and
          revocable at any time, unless a fixed test period has been expressly agreed.
        </p>
        <p className="mb-3">
          (4) There is no entitlement to permanent provision of the software or to the conclusion of
          a paid contract.
        </p>
        <p className="mb-3">
          (5) Insofar as a contractual relationship exists, the provisions of the relevant contract,
          in particular Part A and Part B, apply, where applicable.
        </p>
        <p className="mb-3">
          (6) Test or pilot use may be limited to certain functional areas, modules, or
          organizational sizes. There is no entitlement to transfer the test configuration to a
          productive license structure.
        </p>
        <p className="mb-3">
          (7) Beta modules are marked separately and are not considered contractually owed core
          functionalities. They can be adapted or discontinued at any time without giving rise to
          claims for an extension of the scope of services.
        </p>
      </section>

      <section>
        <h3 className="font-semibold mb-2">§ C-5 Contractually bound use</h3>
        <p className="mb-3">
          (1) Upon termination of the respective permissible period of use, all rights of use
          granted to the customer for the software shall automatically expire without the need for a
          separate declaration.
        </p>
        <p className="mb-3">
          (2) From the time of termination, productive use of the software is not permitted.
        </p>
        <p className="mb-3">
          (3) If the customer is granted a technically necessary transition or export phase after
          termination of the contract, the right of use is limited exclusively to access for the
          purpose of data export or data migration in accordance with § B1-3. Any use beyond this is
          excluded.
        </p>
        <p className="mb-3">
          (4) There shall be no entitlement to continued use, to the renewed granting of rights of
          use, or to the transfer of the software in physical or installable form.
        </p>
      </section>

      <section>
        <h3 className="font-semibold mb-2">§ C-6 Ownership of Rights and Property Rights</h3>
        <p className="mb-3">
          (1) The software and all associated copyrights, industrial property rights, trade secrets,
          and other intellectual property rights are the exclusive property of BLIKS IO or the
          respective rights holders.
        </p>
        <p className="mb-3">
          (2) Suggestions, improvement proposals, or feedback on the software submitted by the
          customer may be used by BLIKS IO free of charge and without time limitation for the
          purposes of further developing and optimizing the software, provided that no confidential
          information of the customer is disclosed or exploited as a result.
        </p>
        <p className="mb-3">
          (3) The customer is not entitled to use BLIKS IO's trademarks, brands, or other
          intellectual property rights outside of the contractual use without express consent.
        </p>
      </section>

      <section>
        <h3 className="font-semibold mb-2">§ C-7 Open Source and Third-Party Components</h3>
        <p className="mb-3">
          (1) The software may contain components that are subject to open source licenses or other
          third-party license terms.
        </p>
        <p className="mb-3">
          (2) If different license terms apply to individual components, these shall take precedence
          with regard to the respective component. This does not grant any further rights.
        </p>
        <p className="mb-3">
          (3) The use of such components is subject to the relevant license terms. This does not
          give rise to any obligation to disclose the source code of the entire software. An
          obligation to disclose the source code only exists if required by mandatory open source
          license terms.
        </p>
      </section>
    </div>
  );
}
